import React, { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Rating,
  Paper,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Feedback as FeedbackIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { submitFeedback } from "../../services/API";
import { styles } from "./FeedbackWidget.styles";

function FeedbackWidget() {
  const [expanded, setExpanded] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [feedbackType, setFeedbackType] = useState("bug");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitFeedback({
        rating,
        comment,
        feedback_type: feedbackType,
      });

      setSnackbar({
        open: true,
        message: "Thank you for your feedback!",
        severity: "success",
      });

      setExpanded(false);
      setRating(0);
      setComment("");
      setFeedbackType("bug");
    } catch (error) {
      setSnackbar({
        open: true,
        message:
          error.message || "Failed to submit feedback. Please try again.",
        severity: "error",
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box sx={styles.widgetContainer}>
      {!expanded ? (
        <Box sx={styles.collapsedWidget} onClick={() => setExpanded(true)}>
          <FeedbackIcon />
        </Box>
      ) : (
        <Paper sx={styles.expandedWidget}>
          <Box sx={styles.header}>
            <Typography variant="h6">Feedback</Typography>
            <IconButton onClick={() => setExpanded(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <form onSubmit={handleSubmit}>
            <Box sx={styles.form}>
              <FormControl component="fieldset" sx={styles.ratingContainer}>
                <Typography component="legend">
                  How would you rate your experience?
                </Typography>
                <Rating
                  value={rating}
                  onChange={(event, newValue) => setRating(newValue)}
                  size="large"
                />
              </FormControl>

              <FormControl
                component="fieldset"
                sx={styles.feedbackTypeContainer}
              >
                <Typography component="legend">Type of feedback</Typography>
                <RadioGroup
                  value={feedbackType}
                  onChange={(e) => setFeedbackType(e.target.value)}
                >
                  <FormControlLabel
                    value="bug"
                    control={<Radio />}
                    label="Bug Report"
                  />
                  <FormControlLabel
                    value="feature"
                    control={<Radio />}
                    label="Feature Request"
                  />
                  <FormControlLabel
                    value="issue"
                    control={<Radio />}
                    label="Customer Issue"
                  />
                  <FormControlLabel
                    value="love"
                    control={<Radio />}
                    label="Sharing Love"
                  />
                </RadioGroup>
              </FormControl>

              <TextField
                label="Your feedback"
                multiline
                rows={4}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                variant="outlined"
                fullWidth
                sx={styles.commentField}
              />

              <Box sx={styles.submitButton}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={!rating || !comment}
                >
                  Submit Feedback
                </Button>
              </Box>
            </Box>
          </form>
        </Paper>
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default FeedbackWidget;
